import styled, { css } from 'styled-components';

export const Root = styled.div`
  ${({ theme, $isMobile }) => css`
    background: ${theme.v3.colors.neutral[100]};
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: fit-content;
    box-sizing: border-box;
    ${$isMobile
    ? css`
          border-top-left-radius: ${theme.v3.border.radius.md};
          border-top-right-radius: ${theme.v3.border.radius.md};
          padding: 28px 0;
        `
    : css`
          border-radius: ${theme.v3.border.radius.md};
          padding: ${theme.v3.spacing.md} ${theme.v3.spacing.md} ${theme.v3.spacing['2xl']};
          gap: ${theme.v3.spacing['2xl']};
        `}
  `}
`;

export const BrandByMonarxWrapper = styled.div`
  ${({ theme, $isMobile }) => css`
    width: 100%;
    margin-bottom: ${theme.v3.spacing.xxxs};
    ${!$isMobile && css`
      margin-bottom: ${theme.v3.spacing.xxs};
    `}
  `}
`;

export const MessageBlock = styled.div`
  ${({ theme, $isMobile }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.v3.spacing.nano};
    align-items: center;
    text-align: center;
    width: 100%;
    max-width: 100%;
    margin-bottom: ${$isMobile ? theme.v3.spacing.xxs : theme.v3.spacing.md};
  `}
`;

export const Headline = styled.h2`
  ${({ theme, $isMobile }) => css`
    margin: 0;
    color: ${theme.v3.colors.brand.snappyBlue[5]};
    font-size: ${$isMobile ? theme.v3.font.sizes['1xlarge'] : theme.v3.font.sizes.huge};
    font-weight: ${theme.v3.font.weights.medium};
    width: 100%;
  `}
`;

export const BodyText = styled.p`
  ${({ theme, $isMobile }) => css`
    margin: 0;
    font-family: ${theme.v3.font.family.brand};
    color: ${theme.v3.colors.neutral[20]};
    font-size: ${$isMobile ? theme.v3.font.sizes['1xmedium'] : theme.v3.font.sizes['1xlarge']};
    font-weight: ${theme.v3.font.weights.regular};
    width: 100%;
    max-width: ${$isMobile ? '100%' : '582px'};

    strong {
      font-weight: ${theme.v3.font.weights.bold};
    }
  `}
`;

export const PrimaryButtonWrap = styled.div`
  ${() => css`
    width: 100%;
    display: flex;
    justify-content: center;
  `}
`;
